import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { MoveToCopyToProjectRow } from './MoveToCopyToProjectRow';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetMoveToCopyToProjectsQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
  page: Types.PageInput;
  projectStatus?: Types.InputMaybe<Array<Types.ProjectStatusInput>>;
  query?: Types.InputMaybe<Types.Scalars['String']['input']>;
  orders?: Types.InputMaybe<Array<Types.ProjectOrderInput>>;
}>;


export type GetMoveToCopyToProjectsQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, projects: { __typename?: 'ProjectConnection', totalCount: number, nodes: Array<{ __typename?: 'Project', rootAssetId: string, fileCount: number, ignoreArchive: boolean, storage: number, id: string, name: string, private: boolean, archivedAt?: string | null, workspace?: { __typename?: 'Workspace', id: string, name: string } | null, images: { __typename?: 'Images', image32?: string | null } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } } | null };


export const GetMoveToCopyToProjects = /*#__PURE__*/ gql`
    query GetMoveToCopyToProjects($accountId: ID!, $page: PageInput!, $projectStatus: [ProjectStatusInput!], $query: String, $orders: [ProjectOrderInput!]) {
  account(accountId: $accountId) {
    id
    projects(
      page: $page
      filter: {projectStatus: $projectStatus, query: $query}
      orders: $orders
    ) {
      nodes {
        ...MoveToCopyToProjectRow
        rootAssetId
        fileCount
        ignoreArchive
        storage
        workspace {
          id
          name
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
}
    ${MoveToCopyToProjectRow}` as unknown as DocumentNode<GetMoveToCopyToProjectsQuery, GetMoveToCopyToProjectsQueryVariables>;

          

          export const useGetMoveToCopyToProjectsQuery = (options?:QueryHookOptions<GetMoveToCopyToProjectsQuery, GetMoveToCopyToProjectsQueryVariables>) => useQuery(GetMoveToCopyToProjects, options);

          

          export type GetMoveToCopyToProjectsQueryOptions = QueryHookOptions<GetMoveToCopyToProjectsQuery, GetMoveToCopyToProjectsQueryVariables>;

          

          export const useGetMoveToCopyToProjectsLazyQuery = (options?:LazyQueryHookOptions<GetMoveToCopyToProjectsQuery, GetMoveToCopyToProjectsQueryVariables>) => useLazyQuery(GetMoveToCopyToProjects, options);

          

          export type GetMoveToCopyToProjectsQueryResult = ReturnType<typeof useGetMoveToCopyToProjectsQuery>;

          
